import React, { useEffect, useState } from "react";
import {
  Modal,
  List,
  Card,
  Upload,
  Button,
  Input,
  Popconfirm,
  message,
  Image,
  Pagination, Spin
} from 'antd';
import {
  UploadOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { deletePoiAsset, fetchPoiDirectory, uploadPoiAssets } from '../../state/actions/poiDirectories';
import { imgUrl } from '../../utils/url';
import "./ModalPoiAssets.scss"

const { Meta } = Card;

const PoiAssetsModal = ({ open, onClose, siteId }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [ pageSize] = useState(12);


  const { assets, total, loading } = useSelector(
    (state) => ({
      assets: state.poidirectories.list,
      total: state.poidirectories.total,
      loading: state.poidirectories.loading,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  // Fetch assets
  useEffect(() => {
    if (open) dispatch(fetchPoiDirectory({search, siteId, page}));
  }, [open, siteId, page, search]); //eslint-disable-line

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handleDelete = async (id) => {
    try {
    await dispatch(deletePoiAsset({id, siteId}, ()=> dispatch(fetchPoiDirectory({search, siteId, page}))));
    } catch (err) {
      message.error("Delete failed");
    }
  };

  const handleUpload = async ({ file }) => {
    dispatch(uploadPoiAssets({file, siteId},()=> dispatch(fetchPoiDirectory({search, siteId, page}))));
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => message.success('Copied to clipboard!'))
      .catch(() => message.error('Failed to copy'));
  };

  return (
    <Modal
      title="POI Assets"
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Input.Search
        placeholder="Search by asset name"
        onSearch={handleSearch}
        allowClear
        enterButton
        className="custom-search"
        style={{ marginBottom: 16, height: 40 }}
      />

      <List
        grid={{ gutter: 16, column: 4 }}
        loading={loading}
        dataSource={assets}
        renderItem={(item) => (
          <List.Item key={item._id}>
            <Card
              hoverable

              cover={
                <Image
                  src={`${imgUrl}/poi/${item.logo}`}
                  alt={item.name}
                  height={150}
                  style={{ objectFit: 'cover' }}
                  preview={{ mask: <EyeOutlined /> }}
                />
              }
              actions={[
                <Popconfirm
                  title="Delete this asset?"
                  onConfirm={() => handleDelete(item._id)}
                >
                  <DeleteOutlined key="delete" />
                </Popconfirm>,
              ]}
            >
              <Meta title={item.name} onClick={()=>copyToClipboard(item.name)} />
            </Card>
          </List.Item>
        )}
      />

      <Pagination
        style={{ marginTop: 16, textAlign: 'right' }}
        current={page}
        pageSize={pageSize}
        total={total}
        onChange={setPage}
        showSizeChanger={false}
      />

      <div style={{ marginTop: 24 }}>
        <Spin spinning={loading}>
          <Upload
            accept="image/*"
            customRequest={handleUpload}
            multiple
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>Upload Images</Button>
          </Upload>
        </Spin>
      </div>
    </Modal>
  );
};

export default PoiAssetsModal;
